import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

const MarketingLayout = ({ children, title, metaDescription }) => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);

    // Update title
    if (title) {
      document.title = title;
    }

    // Update meta description
    if (metaDescription) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = metaDescription;
    }
  }, [location, title, metaDescription]);

  return (
    <div style={{ background: '#ffffff', color: '#1e293b', fontFamily: "'Inter', sans-serif", minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        @keyframes fadeUp { from{opacity:0;transform:translateY(20px);}to{opacity:1;transform:translateY(0);} }
        @keyframes float { 0%{transform:translateY(0px);} 50%{transform:translateY(-10px);} 100%{transform:translateY(0px);} }
        
        .nav-link:hover { color: #3b82f6 !important; }
        .hero-img { animation: float 6s ease-in-out infinite; }
        .animate-fade-up { animation: fadeUp 0.6s ease forwards; }
        
        * { box-sizing: border-box; }
        html, body { margin: 0; padding: 0; }
      `}</style>
      
      <Navbar />
      
      <main style={{ flex: 1 }}>
        {children}
      </main>
      
      <Footer />
    </div>
  );
};

export default MarketingLayout;
